import React from "react";
import "./sema.scss";
import { ArrowButton } from "../../components/arrow-button";
import { PhotoColumn } from "../../components/photo-column";
import { ImageSourceType, PhotoGallery } from "../../components/photo-gallery";
interface SemaCalismasiProps {
    isVisible: boolean;
    comeBackSemaSection: Function;
}
interface SemaCalismasiState {
    Change: boolean;
}

const SemazenNiyaz = require('../../assets/photos/sema-calismasi/semazen-niyaz-400.png');
const EsmaHat = require('../../assets/icons/esma-hat.png');
const SemaTahtasi = require('../../assets/photos/sema-calismasi/sema-tahtasi.jpg');
const SemaIzleme = require('../../assets/photos/sema-calismasi/sema-izleme.jpg');
const SemayaKolAcis = require('../../assets/photos/sema-calismasi/sema-kol-acis.jpg');

const semaCalismasi1 = require('../../assets/photos/sema-calismasi/sema-calismasi-1.jpg');
const semaCalismasi2 = require('../../assets/photos/sema-calismasi/sema-calismasi-2.jpg');
const semaCalismasi3 = require('../../assets/photos/sema-calismasi/sema-calismasi-3.jpg');
const semaCalismasi4 = require('../../assets/photos/sema-calismasi/sema-calismasi-4.jpg');
const semaCalismasi5 = require('../../assets/photos/sema-calismasi/sema-calismasi-5.jpg');
const semaDua = require('../../assets/photos/sema-calismasi/sema-dua-baslangic.jpg');
const kapaliSema = require('../../assets/photos/sema-calismasi/kapali-sema.jpg');
const acikSema = require('../../assets/photos/sema-calismasi/acik-sema.jpg');

let GalleryImages: ImageSourceType[] = [
    {
        src: semaDua,
        altTitle: "Dua ile sema başlangıç çalışması",
        figcaptionFirstTitle: "Sema çalışma şekli 1:",
        figcaptionSecondTitle: "Dua ile sema başlangıç çalışması"
    },
    {
        src: kapaliSema,
        altTitle: "Sema tahtasında kapalı sema çalışması",
        figcaptionFirstTitle: "Sema çalışma şekli 2:",
        figcaptionSecondTitle: "Sema tahtasında kapalı sema çalışması"
    },
    {
        src: acikSema,
        altTitle: "Sema tahtasında açık sema çalışması",
        figcaptionFirstTitle: "Sema çalışma şekli 3:",
        figcaptionSecondTitle: "Sema tahtasında açık sema çalışması"
    },
    {
        src: semaCalismasi2,
        altTitle: "Sema çalışmasında Kasların güçlendirilmesi",
        figcaptionFirstTitle: "Sema çalışma şekli 4:",
        figcaptionSecondTitle: "Sema çalışmasında Kasların güçlendirilmesi"
    },
    {
        src: semaCalismasi3,
        altTitle: "Sema çalışmasında kalçaların güçlendirilmesi",
        figcaptionFirstTitle: "Sema çalışma şekli 5:",
        figcaptionSecondTitle: "Sema çalışmasında kalçaların güçlendirilmesi"
    },
    {
        src: semaCalismasi4,
        altTitle: "Sema çalışmasında bel ve kalça pozisyonu belirleme",
        figcaptionFirstTitle: "Sema çalışma şekli 6:",
        figcaptionSecondTitle: "Sema çalışmasında bel ve kalça pozisyonu belirleme"
    },
    {
        src: semaCalismasi5,
        altTitle: "Sema çalışmasında kolları dik tutma pozisyonu",
        figcaptionFirstTitle: "Sema çalışma şekli 7:",
        figcaptionSecondTitle: "Sema çalışmasında kolları dik tutma pozisyonu"
    },
    {
        src: semaCalismasi1,
        altTitle: "Sema da selamlama duruş pozisyonu",
        figcaptionFirstTitle: "Sema çalışma şekli 8:",
        figcaptionSecondTitle: "Sema da selamlama duruş pozisyonu"
    }
]

class SemaCalismasi extends React.Component<SemaCalismasiProps, SemaCalismasiState>{
    constructor(props: any) {
        super(props);
        this.state = {
            Change: true
        };
    }

    render() {
        return (
            <div style={{ display: this.props.isVisible ? "block" : "none" }} className="sema-exercises">
                <article>
                    <ArrowButton onClick={this.props.comeBackSemaSection} />
                    <h3 className="title">SEMA ÇALIŞMASI <br /> HİKMET VE SIRLARI</h3>
                    <PhotoColumn
                        imageSource={EsmaHat}
                        imageTitle="Sema Çalışması"
                    />

                    <p>
                        İlk önce <span className="highlight-word">SEMA</span> dedesinin huzurunda saf olunur, üç İhlâs bir Fatiha ve bir ayet-el kürsi okunur, Hz. Pir Mevlâna
                        Celaleddin Rumi ve bu yoldan göçen meşayih ve dervişanın ruhlarına hediye edilir ve <span className="highlight-word">SEMA</span>’ya destur alınır.
                        Buna Mutaakip <span className="highlight-word">SEMA</span> dedesi Gülbang-ı Şerif okur.
                    </p>

                    <p className="color-green text-bold-italic">
                        “Vakt-i şerif hayrola, hayırlar fethola, şerler def’ola, derviş kardeşimizin niyazı kabul ola, âşiyan-ı
                        Mevlevîyye’de rahatı müzdad ola, sema çalışmaları feyizyab ola, demler safalar ziyade ola, dem-i Hazret-i
                        Mevlâna, sırr-ı Şems-i Tebrîzi, kerem-i, İmam-ı Ali, Gülbank-ı Muhammedî Hu diyelim”
                    </p>

                    <PhotoColumn
                        imageSource={SemazenNiyaz}
                        imageTitle="Semazen Niyaz Halini alırken"
                        figcaptionFirstTitle="Semazen Niyaz Halini alırken"
                        className="float-left"
                    />

                    <p>
                        Daha sonra çalışacak canlar <span className="highlight-word">SEMA</span>’ya konsantre olurlar. <span className="highlight-word">SEMA</span> için niyaz vaziyeti alınır.
                        Sağ elin parmakları sol omuzun üzerine konarak, sol elin parmakları sağ omuzun üzerine konarak Allah’ın birliğinin tasdiğini temsilen dik durulur. (Mührü-pay)
                    </p>

                    <ol>
                        <li>Vücudu dik tutmak</li>
                        <li>Başı hafif sağa ve geriye doğru çekmek</li>
                        <li>Göğsü dışarı çıkarmak.</li>
                        <li>Karını içeri çekmek</li>
                        <li>Kalçalarını geriye çıkarmak.</li>
                        <li> Bacakları kasmadan elastiki şekilde tutmak.</li>
                        <li>Bu pozisyona dikkat etmek gerekir.</li>
                    </ol>

                    <p>
                        <span className="highlight-word">SEMA </span> çalışmasına ilk başlandığı günlerde, bizim çalışmalarımızda, yüzde üç veya beş kişide baş dönmesi kusma
                        olmuş idi. Bu gayet normaldir. <span className="highlight-word">SEMA</span> çalışmasını ilk günlerde en fazla iki dakika ile beş dakika arasında
                        sınırlı tutmalıdır. Semazenler bu ekzersis sırasında ortaya çıkan bulantı ve kusmayı safra atmak olarak
                        ismlendirirler. Çalışmaların sonuna doğru bu şikâyetlerin kaybolması içindeki safranın temizlenmesi tabiriyle
                        ifade edilmektedir. Derviş canın safradan temizlenmesi, mecazen içindeki kötü yabancı veya faydasız
                        düşüncelerden arınma manasınadır. <span className="highlight-word">SEMA</span>’a başlamak için herhagi bir yaş sınırı bulunmamaktadır. Umumiyetle <span className="highlight-word">SEMA</span>
                        çalışmasına ilk veya orta mektep çağında, 7 ila 15 yaşlarında başlanması uygun olur.
                    </p>

                    <PhotoColumn
                        imageSource={SemaTahtasi}
                        imageTitle="Sema Tahtası"
                        figcaptionFirstTitle="Sema Tahtası"
                        className="float-left"
                    />

                    <p>
                        Sonra <span className="highlight-word">SEMA</span>’yla ilgili çalışmayı gösteriyorum ve bununla ilgili ilk adımı ki bu çok basit. Daha sonra sırasıyla
                        geliniz ve adımlarınızı deneyiniz. Ellerimi göğsümün üstünde çapraz şekilde bağlıyor ve bir Mevlevi Dervişinin
                        duruş şeklini gösteriyorum. Bunun Rükû ve Kıyam arasında yapılan bir hareket olan niyaz olduğunu söylüyor,
                        Altın çivili <span className="highlight-word">SEMA</span> tahtasını getirtiyorum. Meydana koyuyor, üzerine bir kap içerisinde tuz bırakıyorum.
                        Semazene, <span className="highlight-word">SEMA</span>’ya başlamanın sağ elinin dirseğini sol elinin için alarak sağ eliyle <span className="highlight-word">SEMA</span> tahtasındaki <span className="highlight-word">SEMA </span>
                        çivisine bir avuç tuz koyarak başlanacağını söylüyorum. <span className="highlight-word">SEMA</span>’ya başlayacak kişinin <span className="highlight-word">SEMA</span> tahtasına ne niyetle
                        niyaz edeceğini ve <span className="highlight-word">SEMA</span> tahtasının <span className="highlight-word">SEMA</span> SOFRASINI sembolize ettiğini anlatıyorum.
                    </p>

                    <p>
                        <span className="highlight-word">SEMA</span> tahtası Mevlevilikteki 1001 gün çile rakamının sembolünü işaret ediyor. <span className="highlight-word">SEMA</span> tahtasının eni 1 metre 10
                        cm, boyu da 1m 10 cm dir. Merkezdeki altın renkteki çivide Kâbe’yi ve Kâbe’nin Mültezime kapısını ifade
                        ediyor. İşte bu kapıdan <span className="highlight-word">SEMA</span>’ya gir ve kalp Kâbe’sini tavaf ederek <span className="highlight-word">SEMA</span>’ya başlamış oluyorsunuz.
                    </p>

                    <p>
                        Rabıta ve niyaz ederek, Salâvat-ı Şerife getirerek <span className="highlight-word">SEMA</span> tahtasını ve çiviyi öperek Semazen <span className="highlight-word">SEMA</span>’ya girer.
                    </p>
                    <p>
                        <span className="highlight-word">SEMA</span> tahtasında çivi bulunuşu mihveri sabit tutarak devir yapmağa alışabilmek içindi. Tuz, ayak parmaklarının
                        yaralanmasına mani olmak ve kolay hareket edebilmesini sağlamak içindi. Her dönmeyi müteakip biraz durulur,
                        yeniden bir çark yapılır, bu suretle mümarese kazanıldıkça devirler arasına fasıla verilmemekle beraber, sürat
                        artırılır ve hareketler tevali eder, dururdu. Nihayet, Semazen <span className="highlight-word">SEMA</span> tahtasından yere indirilir, <span className="highlight-word">SEMA</span> salonunda
                        çivisiz ve tuzsuz olarak talime devam ettirilirdi.
                    </p>


                    <p>
                        <span className="highlight-word">SEMA</span>’ya itiyat ve ünsiyet hâsıl olunca, artık çark ederken sağ ayak sol dize kadar kaldırılmayarak sol ayağın
                        biraz üstünden arkaya doğru atılıverirdi.
                    </p>

                    <PhotoColumn
                        imageSource={SemaIzleme}
                        imageTitle="Aşçı Dede Sema Çalışmasını İzliyor"
                        figcaptionFirstTitle="Aşçı Dede Sema Çalışmasını İzliyor"
                        className="float-left"
                    />

                    <p>
                        ‘Semazen = <span className="highlight-word">SEMA</span> eden’ler kendi mihverleri üzerinde devir ettikleri gibi, dairevi bir mahrek üzerinde de
                        seyrederlerdi; bu harekette en sonunda talim edilirdi.
                    </p>

                    <p>
                        <span className="highlight-word">SEMA</span> edenler, kolları göğüslerinde çaprazlama bağlı olarak talime başlarlar ve fakat mümarese ilerledikçe (kol
                        açma) talimine de sıra gelirdi. Kolların, gergin bir şekilde iki yana hemen ufki olarak uzatılması, sağ el
                        avucuna - dualarda olduğu gibi - göğe doğru açık ve sol el avucunun ise - yağmur dualarında olduğu gibi - yere
                        doğru çevrik ve sarkık olması lazımdı; kolları uzun müddet bu vaziyette açık ve gergin tutmak ancak idman ile
                        kabil olabilirdi. <span className="highlight-word">SEMA</span> dedesi, Semazene elleriyle yüksek bir yere tutunarak vücudunu sal1andırmasını
                        tekrarlatarak (kol açma) ya alıştırırdı. <span className="highlight-word">SEMA</span> ederken başın dik tutulması, yüzün biraz sola çevrilerek
                        gözlerin yarı kapalı bir halde kalp nahiyesine dikilmesi mutaddı. İşte bu <span className="text-bold-italic">‘direk tutma’</span>, <span className="text-bold-italic">‘dönme veya çark
                            etme’,</span> <span className="text-bold-italic">‘kol açma’</span> ve <span className="text-bold-italic">‘baş tutma’ </span>hareketlerinden ibaretti.
                    </p>

                    <p>
                        Ve <span className="highlight-word">SEMA</span>’ya başlıyorum. Yüzümde şefkatli gülümseyişin ışığı beliriyor. Şaşılacak derecede bir üfleyişle hareket
                        edercesine hafif ve nazikçe kendi ekseni etrafımda dönüyorum. Bu hareketler yerden kalkan bir kuşun kalkışı
                        gibi yavaş ve yumuşak.
                    </p>

                    <p>
                        Her bir talebe yedişer çark atıyor. Size yaptırdığım bu yedişer çark Kâbe’deki Hacıların yaptığı tavafın
                        sembolüdür. Tavafta da yedi şaft bir tavaf sayılır. İnşallah buna devam edeceğiz. Bir ağacın toprağa kök
                        salması gibi sol ayak üzerindeki direğimiz sağlamlaşacak.
                    </p>

                    <p>
                        — <span className="text-bold-italic">“Efendim bu ne zamana kadar devam edecek”</span> diye soruyorlar.
                    </p>

                    <p>
                        — <span className="text-bold-italic">
                            “Buna kapalı <span className="highlight-word">SEMA</span> denir. Kendi kendinize güveniniz gelip direk duruşunuz sağlamlaştığı zaman aşkınız ve
                            imanınız kemale erdikçe bu <span className="highlight-word">SEMA</span> nimette size ikram edilecek.”
                        </span>
                    </p>

                    <p>
                        <span className="highlight-word">SEMA</span>’daki ilk merhale ikmal olmuş oluyor. <span className="highlight-word">SEMA</span> sofrası olan tahtaya niyaz ederekten çiviyi öpüyoruz. <span className="highlight-word">SEMA</span>
                        tahtasını öpüp Salâvat-ı Şerif getirerekten tahtayı yerine kaldırıyoruz. Kollar, sağ kol yukarıya, sol kol
                        aşağıya olmak üzere açılıyor. Çok hafifçe pervane dönüşü etkinleşiyor. Bu bizi duygulandırırken, zamanı da
                        unutturuyor. Odada bir yer çekiminden kurtulmuşluğun duygusunu yaşıyoruz. Zemin üzerinde süzülürken adımların
                        atılışı yerine göre değişiyor! Sağ ayak bir saat gibi kalkıp iniyor ve bununla gerekli olan ivmeyi sağlıyor.
                        Daha sonra <span className="highlight-word">SEMA</span> tekrar yavaşlıyor ve kollar göğüsün üzerinde çapraz konularak kapanıyor. Durduğumda
                        talebelerin önlerinde derince eğiliyorum, onlar da <span className="highlight-word">SEMA</span> dedesinin önünde niyaz ediyorlar.
                    </p>

                    <p>
                        Toplanma ve dinlenmeden bir müddet sonra talebeleri davet ediyorum:
                    </p>
                    <p>
                        <span className="text-bold-italic">
                            “Evet, şimdi sizin sıranız. Görüyor musunuz, temel duruş. Her iki ayakla zeminde duruluyor. Sol ayak biraz öne
                            atılmış. Vücut ağırlığı sol ayak üzerinde ve her defasında sağ ayakla vücudun tamamını bir çeyrek
                            döndürüyoruz. Şimdi bunu deneyiniz lütfen!”
                        </span>
                    </p>

                    <PhotoColumn
                        imageSource={SemayaKolAcis}
                        imageTitle="Sema'ya kol açan Semazen"
                        figcaptionFirstTitle="Sema'ya kol açan Semazen"
                        figcaptionSecondTitle="bir kuşun yerden kalkışı gibi hafif..."
                        className="float-left"
                    />

                    <p>
                        Sessiz ve dikkatlice <span className="highlight-word">SEMA</span>’daki ilk dönme denemelerini yapıyorlar. Bu oluyor mu? diye soruyorlar. Sol ayak
                        çevresinde dönme, zımpara kâğıdı üzerinde dönme gibi hissediliyor. “Buradan sadece yavaşça kaymanın durması
                        gibi bir şey çıkıyor.“ diye yorumda bulunuyorlar.
                    </p>

                    <p>
                        Zorda oldukları belli, teselli ederek cesaret veriyorum. Yine burada ilk düzeltmeyi de yapıyoruz: <span className="text-bold-italic">
                            “Hayır, futbol ayakları üzerinde durulmayacak! Ayak tam olarak zeminde duruyor - bu vals yapmak değil, bilakis bu bir
                            <span className="highlight-word"> SEMA</span>..!”
                        </span>
                    </p>

                    <p>
                        Söylemesi yapmasından kolay! Bu iş zahmetli ve alışılmadık bir şey. Zamanla vücutta farklı gerilmeler meydana
                        geliyor. Her şey bilinçli olarak yapılmakta, nedenleri açığa çıkarılmakta ve duruş düzeltilmekte. Ya baş çok
                        fazla eğik veya sol ayak çok hareketsiz, sağ omuz bükülü veya topuk dönmede kalkık bir halde. Buna benzer çoğu
                        şeyi yanlış yapıyorlar ve her defasında tekrar baştan başlatıyoruz. Talebelere şakayla ruhen bisiklet sürmenin
                        ilk dersinin (alıştırmasının) sona erdiğini söylediğimde gerçekten mutlular. Ama biliyorum ki her tarafları
                        ağrıyor. Bu kadarını hangisi düşünebilirdi! Basit gibi görünmesine rağmen, böyle bir etki bırakması. Hafifçe
                        gülümseyerek bu durumu yorumluyorum:
                    </p>

                    <p>
                        <span className="text-bold-italic">
                            “Bu çok iyiydi! Bu temel alıştırmayı (eğitimi) bundan böyle uzun süreli olmamak kaydıyla günde birkaç kez
                            yapınız. Daha sonra bakacağız! Çayımızı içelim ve ben size <span className="highlight-word">SEMA</span> ile ilgili bir şeyler anlatayım.”
                        </span> Buna seviniyorlar. Hep birlikte <span className="highlight-word">SEMA</span> Meydanı üzerinde oturuyoruz.
                        Çay önümüzde duruyor ve <span className="highlight-word">SEMA</span> Dedesi olarak anlatmaya başlıyorum:
                    </p>

                    <p>
                        <span className="text-bold-italic">
                            “Şunu öğrenmelisiniz ki, sufi yolu bilmeye, tanımaya ve icraata dayanan öğretinin birliğidir. Ancak gerçek
                            ilim, bizim gelenekte istenildiği kadar bulunan bir meta değildir.
                            Bu daha çok kendisini doğru niyetle yapmaya ve alıştırmaya verenlere açık yaşayan bir niteliktir. Bu sizin
                            için belki anlamakta o kadar kolay olmayabilir, zira Batılı insanlar daha çok inanmaya, bilgiyi kitaplardan
                            almaya veya okullarda ve üniversitelerde edinmeye meyilliler.
                            Bu doğru değil! Kitaplardan sadece enformasyon ve örnek olarak neyi nerede aranacağına dair işaret
                            alınmaktadır! Bunun haricinde başka bir şey yok!” </span> diyerek devam ediyorum:
                    </p>

                    <p>
                        <span className="text-bold-italic">
                            “Şayet siz <span className="highlight-word">SEMA</span> ile ilgili gerçek bilgiyi almak isterseniz, <span className="highlight-word">SEMA</span> yapmalısınız! Bunun başka bir yolu yoktur!
                            Bisiklet sürmek örneğinde size bilgi ve enformasyon arasındaki hassas farkı göstermek istiyorum: Bisiklet
                            sürme bisiklet sürerek öğreniliyor! Bir kılavuz bana bu konuda gerekli olan enformasyonu ve bununla öğrenmeye
                            başlama fırsatını veriyor. Ancak bu hiç ama hiçbir zaman bisiklet sürmenin yerine geçmiyor. Alıştırmayla bir
                            gün kendi kendine ‘hah işte bu!’ olayı vuku buluyor: Bisiklet sürebiliyorum!”
                        </span>
                    </p>
                    <p>
                        <span className="text-bold-italic">
                            “Sufi yolunda insan ‘bu dünya ve diğer dünyada’ aynı zamanda var olma gayreti gösteriyor. Bu hayattaki
                            dengenin ta kendisidir. <span className="highlight-word">SEMA</span>’daki hareket akışı buna bir mecaz oluşturur. Sol ayağın zemin üzerinde tam olarak
                            oturması ve sağ ayağın dönme hareketini akıcı kılmak için kaldırılması <span className="highlight-word">SEMA</span>’daki hareketin akışına bir
                            mukayesedir.”
                        </span>
                    </p>
                    <p>
                        <span className="text-bold-italic">
                            “Büyük <span className="highlight-word">SEMA</span> merasimi bir kozmik halka oyunu gibidir: Kâinatın içerisinde herşey birbirine karşı mükemmel bir
                            şekilde dengelenmiş, birbiriyle ve birlikte tam bir teveccüh içerisinde bulunuyorlar.
                        </span>
                    </p>

                    <p>
                        <span className="text-bold-italic">
                            Öyle ki, istenildiği anda kişi kendi kendine dönmeye başlayamıyor. Semazen önce Şeyhine gidiyor, ‘<span className="highlight-word">SEMA</span>’ için
                            ondan izin istiyor. Her ikisi birbirinin gözüne baktığı esnada izin veriliyor. <span className="highlight-word">SEMA</span>’da her şeyin ayrı bir
                            anlamı ve ayrı bir yeri var. <span className="highlight-word">SEMA</span> merasimi müzikle birlikte başlıyor. Bu ney ve kudüm eşliğinde ölümün ve
                            yeniden dirilişin bir törenidir. ‘Ölmeden önce öl!‘ İşte mesaj budur.”
                        </span>
                    </p>

                    <p>
                        <span className="text-bold-italic">
                            “İlk <span className="highlight-word">SEMA</span> ile birlikte “iyi haberin duyulması“ ifade edilmektedir. Şüphe yok ki, başka ve daha iyi bir hayat
                            mümkündür. Oraya giden yol açıktır. İkinci <span className="highlight-word">SEMA</span> ile birlikte Semazen hakikate dönüyor. Semazen çoğu insanın
                            aradığını ancak herkesin bulamadığını görmeye başlıyor. Üçüncü <span className="highlight-word">SEMA</span>’da kalbin hasreti kesinleşmekte ve eve
                            giden yol bulunmaktadır. İnsan ve ALLAH arasındaki ayrılık son bulmuştur. ALLAH, iş yapmak için sadece elimin,
                            duymak için sadece kulağımın ve insan olmak için sadece kalbimin sahibidir. Dördüncü <span className="highlight-word">SEMA</span> ile birlikte
                            ‘ALLAH’la uyum içinde olmak’ için <span className="highlight-word">SEMA</span> ediliyor. Gösterilen çabalar amacına ulaşmıştır. O ve ben biriz!”
                        </span>
                    </p>

                    <p>
                        <span className="text-bold-italic">
                            “Bununla Mevlâna sufilerinin iddialı yolu tanıtılmıştır. Adaylar için neden uzun bir hazırlık ve imtihan
                            süresinin gerekli olduğunu belki daha iyi anlayabilirsiniz. Yolun bu bölümünde, ilme nasıl münasip bir tavırla
                            yaklaşılacağı öğretilmektedir. Arayan şimdi egosunu kontrol altına aldı ve artık hislerinin ve hayali
                            arzularının açlığına daha fazla boyun eğmiyor. Bu yol, doğru bilginin yoludur. Tecrübe, bu bilginin bir
                            devamıdır. Arayan bu ilmi çok sayıda yaptığı alıştırma esnasında eritti. Evet, o, bilgiyi doğru bir şekilde de
                            kullanacağı konumuna geldi.”
                        </span>
                    </p>

                    <p>
                        <span className="text-bold-italic">
                            “O, <span className="highlight-word">SEMA</span> ile dünyanın her yerinde ve her an sufi yolunda gidebilecek konuma geldi. Bunun için onun ne akideye,
                            ne kendinden vazgeçmeye ve ne de hayattan elini eteğini çekmeye ihtiyacı yoktur. Zira bu yol insan varlığının
                            iç esaslarıyla uyuşmaktadır. ALLAH’a bir kez köklü teslimiyet, insanın gerçek özgürlüğüdür. Böylece, imanıyla
                            özgürlüğünü garanti altına almış hür bir insan olunuyor. Semazen aynı zamanda Allah’ın vitrinidir. Dünyanın
                            her yerinde tüm kapılar size açılıyor. <span className="highlight-word">SEMA</span> bir duadır ve Semazende bütün insanlık için bir barış melekesi
                            oluşuyor. Bu yüzden tüm dünya devletleri tarafından ziyarete çağırılıyoruz, dünyanın barışına katkı yapmak ve
                            <span className="highlight-word"> SEMA</span>'daki sevgiyi göstermek üzere sağ elimize Hak’tan rahmet alıp sol elimizle halka saçıyoruz. Bununla ilgili
                            sorularınız var mı? Bu yolu gitmek istiyor musunuz?”
                        </span>
                    </p>

                    <p>
                        Soruları yok. Son soruma “Evet!” cevaplarıyla birlikte uzun süreli alıştırma, düzeltme ve azimle hâlâ devam
                        eden iç gelişme başlıyor ve içlerindeki ihtiras, hırs, kin, kasavet, egonun düzeltilmesine geçiliyor.
                    </p>

                    <p>
                        <span className="highlight-word">
                            “Gerçekten de biz ALLAH’tan geldik ve O’na döndürüleceğiz”
                        </span>
                    </p>
                </article>

                <div className="sema-calismasi-title">
                    <span>SEMA ÇALIŞMALARI</span>
                </div>

                <PhotoGallery imageSources={GalleryImages} />
            </div>
        );
    }
}

export default SemaCalismasi;